/**
 * TypeScript types that correspond to the Bridge by Smartsheet Parameter Schema.
 */

export const ParamSchemaTypes = {
  TEXT: 'TEXT' as const,
  PASSWORD: 'PASSWORD' as const,
  STRING: 'STRING' as const,
  HTML: 'HTML' as const,
  JSON: 'JSON' as const,
  'DERIVED-JSON': 'DERIVED-JSON' as const,
  DERIVED: 'DERIVED' as const,
  NUMBER: 'NUMBER' as const,
  BOOLEAN: 'BOOLEAN' as const,
  PARAM: 'PARAM' as const,
  ENUM: 'ENUM' as const,
  'BRIDGE.WORKFLOW': 'BRIDGE.WORKFLOW' as const,
  MAP: 'MAP' as const,
  'HTML.LINK': 'HTML.LINK' as const,
};

export type ParamSchemaTypes = keyof typeof ParamSchemaTypes;

export type PrimitiveParamSchemaTypes =
  | typeof ParamSchemaTypes.TEXT
  | typeof ParamSchemaTypes.PASSWORD
  | typeof ParamSchemaTypes.STRING
  | typeof ParamSchemaTypes.NUMBER
  | typeof ParamSchemaTypes.HTML
  | typeof ParamSchemaTypes.JSON
  | typeof ParamSchemaTypes.ENUM
  | typeof ParamSchemaTypes['BRIDGE.WORKFLOW']
  | typeof ParamSchemaTypes['DERIVED-JSON']
  | typeof ParamSchemaTypes.DERIVED
  | typeof ParamSchemaTypes.BOOLEAN
  | typeof ParamSchemaTypes['HTML.LINK'];

export type GroupParamSchemaTypes = typeof ParamSchemaTypes.PARAM;

export interface BaseParamSchema<T extends ParamSchemaTypes> {
  type: T;
  param: string;
  displayName?: string;
  description?: string;
  readOnly?: boolean;
  optional?: boolean;
  allowArray?: boolean;
  arrayItemsLabel?: string;
  hide?: boolean;
  hideExpression?: string;
  isOpen?: boolean;
}

export type PrimitiveParamSchema = BaseParamSchema<
  | typeof ParamSchemaTypes.TEXT
  | typeof ParamSchemaTypes.PASSWORD
  | typeof ParamSchemaTypes.STRING
  | typeof ParamSchemaTypes.HTML
  | typeof ParamSchemaTypes.JSON
  | typeof ParamSchemaTypes['DERIVED-JSON']
  | typeof ParamSchemaTypes.DERIVED
  | typeof ParamSchemaTypes.NUMBER
  | typeof ParamSchemaTypes.BOOLEAN
  | typeof ParamSchemaTypes['HTML.LINK']
>;

export interface GroupParamSchema
  extends BaseParamSchema<typeof ParamSchemaTypes.PARAM> {
  valueParams: ParamSchema[];
}

export interface EnumParamSchema
  extends BaseParamSchema<typeof ParamSchemaTypes.ENUM> {
  value: Array<string | { label: string; value: string; selected?: boolean }>;
}

export interface WorkflowParamSchema
  extends BaseParamSchema<typeof ParamSchemaTypes['BRIDGE.WORKFLOW']> {
  value: Array<{ label: string; value: string; selected?: boolean }>;
}

export interface HtmlLinkParamSchema
  extends BaseParamSchema<typeof ParamSchemaTypes['HTML.LINK']> {
  value: { label: string; value: string };
}

export type MapParamSchema = BaseParamSchema<typeof ParamSchemaTypes.MAP>;

export type ParamSchema =
  | PrimitiveParamSchema
  | GroupParamSchema
  | EnumParamSchema
  | WorkflowParamSchema
  | MapParamSchema;
